/** Inclusive valid range for a player's seed/current handicap index. Kept in one
 *  place so the input min/max, the validation bounds, and the error message can
 *  never drift apart. */
export const HANDICAP_MIN = -10;
export const HANDICAP_MAX = 54;

export const HANDICAP_RANGE_MESSAGE = `Must be between ${HANDICAP_MIN} and ${HANDICAP_MAX}.`;

/**
 * Validate a handicap text input. Returns an error message, or undefined when
 * the value is blank (the field is optional) or a valid number within range.
 */
export function validateHandicapField(value: string): string | undefined {
  if (value === "") return undefined;
  const v = Number(value);
  if (isNaN(v)) return "Enter a valid number.";
  if (v < HANDICAP_MIN || v > HANDICAP_MAX) return HANDICAP_RANGE_MESSAGE;
  return undefined;
}
